// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   IDENTITY VERIFICATION SCREEN - ACCELLOR BRANDING
   ========================================== */

.identity-container {
  min-height: 100vh;
  background: var(--interview-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--interview-space-3xl) var(--interview-space-lg);
  font-family: var(--interview-font-primary);
}

.identity-jobBadge {
  background-color: var(--interview-success-light);
  border: 1px solid var(--interview-success-border);
  border-radius: var(--interview-radius-2xl);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
}

.identity-jobIcon {
  width: 36px;
  height: 36px;
  border-radius: var(--interview-radius-md);
  background: var(--interview-success-lighter);
  color: var(--interview-success-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.identity-jobInfo {
  flex: 1;
  min-width: 0;
}

.identity-jobTitle {
  font-size: var(--interview-text-sm);
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0 0 2px 0;
  line-height: 1.4;
}

.identity-jobMeta {
  font-size: 0.75rem;
  color: var(--interview-text-muted);
  margin: 0;
  line-height: 1.4;
}

.identity-heading {
  font-size: 1.4375rem;
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0 0 7px 0;
  text-align: center;
  line-height: 1.3;
  letter-spacing: 0;
}

.identity-subheading {
  font-size: 0.875rem;
  color: var(--interview-text-muted);
  margin: 0 0 24px 0;
  text-align: center;
  line-height: 1.6;
  font-weight: var(--interview-text-regular);
}

.identity-formSection {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 6px;
}

.identity-footer {
  text-align: center;
  font-size: 0.75rem;
  color: var(--interview-text-disabled);
  margin-top: 14px;
  line-height: 1.6;
}

.identity-privacyLink {
  color: var(--interview-brand-primary);
  text-decoration: none;
  font-weight: var(--interview-text-medium);
  transition: color var(--interview-transition-base);
}

.identity-privacyLink:hover {
  color: var(--interview-brand-primary-dark);
  text-decoration: underline;
}

.identity-errorMessage {
  background-color: var(--interview-error-light);
  color: var(--interview-error-dark);
  padding: var(--interview-space-md) var(--interview-space-lg);
  border-radius: var(--interview-radius-md);
  font-size: 0.875rem;
  margin-bottom: var(--interview-space-lg);
  text-align: center;
  line-height: 1.6;
  font-weight: var(--interview-text-medium);
}

@media (max-width: 576px) {
  .identity-heading {
    font-size: var(--interview-text-xl);
  }

  .identity-subheading {
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Interview/IdentityVerification/IdentityVerification.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,iDAAiD;EACjD,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,4CAA4C;EAC5C,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,4DAA4D;EAC5D,yCAAyC;EACzC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* ==========================================\n   IDENTITY VERIFICATION SCREEN - ACCELLOR BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.identity-container {\n  min-height: 100vh;\n  background: var(--interview-bg-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--interview-space-3xl) var(--interview-space-lg);\n  font-family: var(--interview-font-primary);\n}\n\n.identity-jobBadge {\n  background-color: var(--interview-success-light);\n  border: 1px solid var(--interview-success-border);\n  border-radius: var(--interview-radius-2xl);\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.identity-jobIcon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--interview-radius-md);\n  background: var(--interview-success-lighter);\n  color: var(--interview-success-dark);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.identity-jobInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.identity-jobTitle {\n  font-size: var(--interview-text-sm);\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0 0 2px 0;\n  line-height: 1.4;\n}\n\n.identity-jobMeta {\n  font-size: 0.75rem;\n  color: var(--interview-text-muted);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.identity-heading {\n  font-size: 1.4375rem;\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0 0 7px 0;\n  text-align: center;\n  line-height: 1.3;\n  letter-spacing: 0;\n}\n\n.identity-subheading {\n  font-size: 0.875rem;\n  color: var(--interview-text-muted);\n  margin: 0 0 24px 0;\n  text-align: center;\n  line-height: 1.6;\n  font-weight: var(--interview-text-regular);\n}\n\n.identity-formSection {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-bottom: 6px;\n}\n\n.identity-footer {\n  text-align: center;\n  font-size: 0.75rem;\n  color: var(--interview-text-disabled);\n  margin-top: 14px;\n  line-height: 1.6;\n}\n\n.identity-privacyLink {\n  color: var(--interview-brand-primary);\n  text-decoration: none;\n  font-weight: var(--interview-text-medium);\n  transition: color var(--interview-transition-base);\n}\n\n.identity-privacyLink:hover {\n  color: var(--interview-brand-primary-dark);\n  text-decoration: underline;\n}\n\n.identity-errorMessage {\n  background-color: var(--interview-error-light);\n  color: var(--interview-error-dark);\n  padding: var(--interview-space-md) var(--interview-space-lg);\n  border-radius: var(--interview-radius-md);\n  font-size: 0.875rem;\n  margin-bottom: var(--interview-space-lg);\n  text-align: center;\n  line-height: 1.6;\n  font-weight: var(--interview-text-medium);\n}\n\n@media (max-width: 576px) {\n  .identity-heading {\n    font-size: var(--interview-text-xl);\n  }\n\n  .identity-subheading {\n    font-size: 0.875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
